(() => {
  if (window.weaversVillaVariantMediaFilter) {
    window.weaversVillaVariantMediaFilter.refresh(document);
    return;
  }

  const gallerySelector = 'media-gallery[data-colour-option-name]';
  const hiddenClass = 'variant-media--hidden';
  const pending = new Set();
  let frame = null;

  function normalizeColour(value) {
    return String(value || '').toUpperCase().replace(/[\s_-]+/g, '');
  }

  function normalizeSku(value) {
    return String(value || '').trim().toUpperCase().replace(/[\s_-]+/g, '-');
  }

  function filenameStem(value) {
    let filename = String(value || '').split('?')[0].split('#')[0].split('/').pop();
    try {
      filename = decodeURIComponent(filename);
    } catch {}
    return filename.replace(/\.[^.]+$/, '');
  }

  function getPicker(gallery) {
    const section = gallery.id.replace(/^MediaGallery-/, '');
    return Array.from(document.querySelectorAll('variant-radios, variant-selects'))
      .find(picker => picker.dataset.section === section);
  }

  function currentColour(gallery) {
    const picker = getPicker(gallery);
    const optionName = gallery.dataset.colourOptionName;
    const radio = picker && Array.from(picker.querySelectorAll('input[type="radio"]:checked'))
      .find(input => input.name === optionName);
    if (radio) return normalizeColour(radio.value);
    const select = picker && Array.from(picker.querySelectorAll('select'))
      .find(input => input.name === 'options[' + optionName + ']');
    return normalizeColour(select ? select.value : gallery.dataset.selectedColour);
  }

  function getSkuColours(gallery) {
    const script = gallery.querySelector('script[data-variant-media-map]');
    if (!script) return [];
    try {
      const records = JSON.parse(script.textContent);
      if (!Array.isArray(records)) return [];
      return records.map(record => ({
        sku: normalizeSku(record.sku),
        colour: normalizeColour(record.colour)
      })).filter(record => record.sku && record.colour);
    } catch {
      return [];
    }
  }

  function matchedColours(filename, records, knownColours) {
    const stem = filenameStem(filename);
    const skuStem = normalizeSku(stem);
    const matches = records.filter(record =>
      skuStem === record.sku ||
      (skuStem.startsWith(record.sku + '-') &&
        /^\d+(?:-|$)/.test(skuStem.slice(record.sku.length + 1)))
    );
    if (matches.length) {
      const longest = Math.max(...matches.map(record => record.sku.length));
      return matches.filter(record => record.sku.length === longest)
        .map(record => record.colour);
    }
    const colourStem = normalizeColour(stem);
    const colours = knownColours.filter(colour => colourStem.includes(colour));
    const longest = Math.max(0, ...colours.map(colour => colour.length));
    return colours.filter(colour => colour.length === longest);
  }

  function applyFilter(gallery) {
    if (!gallery.isConnected || !gallery.dataset.colourOptionName) return;
    const records = getSkuColours(gallery);
    const knownColours = [...new Set([
      ...(gallery.dataset.colourValues || '').split('|').map(normalizeColour),
      ...records.map(record => record.colour)
    ].filter(Boolean))];
    const selected = currentColour(gallery);
    const canFilter = selected && knownColours.includes(selected);

    gallery.querySelectorAll('li[data-media-filename]').forEach(item => {
      const colours = matchedColours(item.dataset.mediaFilename, records, knownColours);
      const show = !canFilter || !colours.length || colours.includes(selected);
      item.classList.toggle(hiddenClass, !show);
    });

    const slides = Array.from(gallery.querySelectorAll('li[data-media-id]'));
    const active = slides.find(slide => slide.classList.contains('is-active'));
    if (!active || active.classList.contains(hiddenClass)) {
      const visible = slides.filter(slide => !slide.classList.contains(hiddenClass));
      const next = visible.find(slide =>
        matchedColours(slide.dataset.mediaFilename, records, knownColours).includes(selected)
      ) || visible[0];
      if (next && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(next.dataset.mediaId, false);
      }
    }
  }

  function refresh(root) {
    if (root.matches && root.matches(gallerySelector)) applyFilter(root);
    root.querySelectorAll(gallerySelector).forEach(applyFilter);
  }

  function schedule(gallery) {
    pending.add(gallery);
    if (frame !== null) return;
    frame = requestAnimationFrame(() => {
      frame = null;
      pending.forEach(applyFilter);
      pending.clear();
    });
  }

  window.weaversVillaVariantMediaFilter = { refresh };

  document.addEventListener('change', event => {
    const picker = event.target.closest && event.target.closest('variant-radios, variant-selects');
    if (!picker || !picker.dataset.section) return;
    const gallery = document.getElementById('MediaGallery-' + picker.dataset.section);
    if (gallery && gallery.matches(gallerySelector)) schedule(gallery);
  }, true);

  document.addEventListener('shopify:section:load', event => refresh(event.target));
  window.addEventListener('pageshow', () => refresh(document));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => refresh(document), { once: true });
  } else {
    refresh(document);
  }
})();

